import React, {useContext} from 'react';
import {ShopContext} from "../Context/ShopContext";
import {useParams} from "react-router-dom";
import Breadcrum from "../Components/Breadcrums/Breadcrum";
import ProductDisplay from "../Components/ProductDisplay/ProductDisplay";

const Product = () => {
    const {all_product} = useContext(ShopContext);
    const {productId} = useParams();
    const product = all_product.find((e) => e.id === Number(productId));
    return (
        <section className='ProductDisplay-box'>
            <div className='content-wrap'>
                <Breadcrum product={product}/>
                <ProductDisplay product={product}/>
            </div>
        </section>
    )
}

export default Product;